import { Protocol } from "src/app/ui/models/domains/pbm/protocol";

export function parseProtocol(payload: any): Protocol {
  return new Protocol(payload.Number);
}
